export const CONFIG = {
  "PROJECTNAME": "elbey",
  "COMPANYNAME": "Elbey",
  "DFTLNGCODE": "de",
  "URL": "https://api.fbsshop.de",
  "PAYMENTSERVER": "https://stripe.mobiapi.de",
  "VENDORID": "10008150",
  "IMAGEURL": "/images",
  "PAYMENTSYSTEM": false,
  "BANNER": false,
  "BRANDS": false,
  "FLAG_ITEM_ON_HAND": false,
  "MENU_LOGO_BACKGROUND": false,
  "LOGO_LOGIN_BACKGROUND": true,
  "MENU_WHITE_BACKGROUND": false,
  "colors": {
    "primary": "#023b64",
    "primary100": "#e5ebef",
    "light": "#94b93e",
    "secondary": "#023b64",
    "dark": "#023b64",
    "menuPrimary": "#e5ebef",
    "menuSecondary": "#023b64"
  }
};